import actionTypes from 'src/modules/redux/actionTypes'

export const setFavouriteProfilesLoading = isLoading => ({
  type: actionTypes.SET_FAVOURITE_PROFILES_LOADING,
  payload: isLoading
})